export default __webpack_public_path__ + "static/media/group-option-birthday-unselected.47d4b5f5.svg";